import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import SliderProducts from 'components/Home/SliderProductsBanner/SliderProducts';
import ProductsActions from 'actions/Product'
import TitleWithBar from 'components/TitleWithBar';
import style from './style.scss';//NOSONAR


const SimilarProducts = ({skuId, categoryId, type, campaignData}) => {
    const [productsSimilar, setSimilar] = useState(null);
    const [productsLoader, setLoader] = useState(false);
    const [showSimilarProduct, setshowSimilarProduct] = useState(true);

    useEffect(() => {

        if(skuId && campaignData){
            setLoader(true);
            return ProductsActions.getRecommended(false,skuId, campaignData && campaignData.campaign, campaignData && campaignData.filter, type, categoryId).then((response) => {
                if(response && response.length > 1){
                    setSimilar(response);
                    setshowSimilarProduct(true);
                }else{
                    setshowSimilarProduct(false);
                }
                setLoader(false);
            });
        }

    }, [skuId, campaignData]);


    return (showSimilarProduct && <div className="products-similar">
        <TitleWithBar title="Productos Similares" customClassName="products-similar-title" />
        <SliderProducts products={productsSimilar} isLoading={productsLoader} listTitle={'Productos Similares'} notPDP={false} stockOnly={true}/>
    </div>)
}


SimilarProducts.propTypes = {
    skuId: PropTypes.string,
    categoryId: PropTypes.string,
    type: PropTypes.string,
    campaignData: PropTypes.object
};

export default SimilarProducts;
